import { useEffect } from 'react'

import { AlgoEditorThemes } from '../data'

const useMonacoThemes = (monaco: any) => {
  useEffect(() => {
    if (!monaco) return

    const loadThemes = async () => {
      for (const theme of AlgoEditorThemes) {
        try {
          const tmTheme = await import(
            `monaco-themes/themes/${theme.label}.json`
          )
          monaco.editor.defineTheme(theme.id, tmTheme)
        } catch (e) {}
      }
    }

    loadThemes()
  }, [monaco])
}

export default useMonacoThemes
